import { ReactComponent as IconNotification } from "../../../assets/images/svg/shopping-cart.svg";
import { ReactComponent as Report } from "../../../assets/images/svg/guidance/report.svg";
import { ReactComponent as Upload } from "../../../assets/images/svg/guidance/upload-icon.svg";
import { ReactComponent as Folder } from "../../../assets/images/svg/guidance/folder-open.svg";
import { ReactComponent as Cloud } from "../../../assets/images/svg/guidance/folder-cloud.svg";
import { ReactComponent as User } from "../../../assets/images/svg/guidance/user-add.svg";
import { ReactComponent as Frame } from "../../../assets/images/svg/guidance/frame.svg";
import { isTouchScreen } from "../../../scripts/helpers";
import { ENVIRONMENT } from "../../../environment";
import { Suspense, lazy } from "react";

const People1 = lazy(() => import("../../../assets/images/svg/guidance/People (1).svg").then((img) => ({ default: img.ReactComponent })));
const People2 = lazy(() => import("../../../assets/images/svg/guidance/People (2).svg").then((img) => ({ default: img.ReactComponent })));
const People3 = lazy(() => import("../../../assets/images/svg/guidance/People (3).svg").then((img) => ({ default: img.ReactComponent })));
const stepsMobile = [
    {
        disableBeacon: true,
        step: "memory-show",
        content: (
            <div className="w-full h-full flex justify-start items-start gap-2">
                <div>
                    <IconNotification />
                </div>
                <div className="font-normal text-[12px]">{"در این قسمت می‌توانید حافظه مصرفی خود را مدیریت کنید."}</div>
            </div>
        ),
        placement: "top-start",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".memory-show",
        title: ""
    },
    {
        step: "new-upload-mobile",
        content: (
            <div className="w-full h-full flex items-start gap-2">
                <div>
                    <Folder />
                </div>
                <div className="font-normal text-[12px]">{"در این قسمت می‌توانید پوشه جدید اضافه کنید یا فایل‌های موردنظر خود را آپلود کنید."}</div>
            </div>
        ),
        placement: "top-start",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".new-upload-mobile",
        title: ""
    },
    {
        step: "new-upload-link-mobile",
        content: (
            <div className="w-full h-full flex items-start gap-2">
                <div>
                    <Cloud />
                </div>
                <div className="font-normal text-[12px]">
                    {`در این قسمت می‌توانید لینک فایل موردنظر را کپی کنید تا در ${ENVIRONMENT.brandName} شما بارگذاری شود.`}
                </div>
            </div>
        ),
        placement: "top-start",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".new-upload-link-mobile",
        title: ""
    },
    {
        step: "contact-sidebar",
        content: (
            <div className="w-full h-full flex flex-col items-center justify-center gap-4">
                <div className="w-full h-full flex items-start gap-2">
                    <div>
                        <User />
                    </div>
                    <div className="font-normal text-[12px]">
                        {`در این قسمت می‌توانید دوستان خود را به ${ENVIRONMENT.brandName} اضافه کرده و فایل‌های خود را آن‌ها به اشتراک بگذارید.`}
                    </div>
                </div>
                <div className="flex flex-col w-full items-center">
                    <div
                        className="flex items-center justify-between h-[33px] px-2 w-[216px]"
                        style={{
                            boxShadow: "0px 8.38095px 31.4286px rgba(112, 144, 176, 0.12)"
                        }}
                    >
                        <div>
                            <Suspense fallback={<div className="skeleton"></div>}>
                                <People1 />
                            </Suspense>
                        </div>
                        <div className="w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]" />
                        <div className={"w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]"} />
                    </div>
                </div>
            </div>
        ),
        placement: "bottom-start",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".contact-sidebar",
        title: ""
    },
    {
        step: "report",
        content: (
            <div className="w-full h-full flex flex-col items-center gap-6">
                <div className="w-full h-full flex items-start gap-2">
                    <div>
                        <Frame />
                    </div>
                    <div className="font-normal text-[12px]">
                        {"در این قسمت می‌توانید گزارشی کامل از فعالیت‌های خود در بازه زمانی دلخواه مشاهده کنید."}
                    </div>
                </div>
                <div>
                    <Report width={270} height={100} />
                </div>
            </div>
        ),
        placement: "top",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".report",
        title: ""
    }
];

const stepsDesktop = [
    {
        disableBeacon: true,
        step: "memory-show",
        content: (
            <div className="w-full h-full flex justify-start items-start gap-2">
                <div>
                    <IconNotification />
                </div>
                <div className="font-normal text-[14px]">{"در این قسمت می‌توانید حافظه مصرفی خود را مدیریت کنید."}</div>
            </div>
        ),
        placement: "left",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".memory-show",
        title: ""
    },
    {
        step: "new-upload",
        content: (
            <div className="w-full h-full flex items-start gap-2">
                <div>
                    <Folder />
                </div>
                <div className="font-normal text-[14px]">{"در این قسمت می‌توانید پوشه جدید اضافه کنید یا فایل‌های موردنظر خود را آپلود کنید."}</div>
            </div>
        ),
        placement: "left",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".new-upload",
        title: ""
    },
    {
        step: "new-upload-link",
        content: (
            <div className="w-full h-full flex flex-col items-center gap-6">
                <div className="w-full h-full flex items-start gap-2">
                    <div>
                        <Cloud />
                    </div>
                    <div className="font-normal text-[14px]">
                        {`در این قسمت می‌توانید لینک فایل موردنظر را کپی کنید تا در ${ENVIRONMENT.brandName} شما بارگذاری شود.`}
                    </div>
                </div>
                <div>
                    <Upload />
                </div>
            </div>
        ),
        placement: "left",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: ".new-upload-link",
        title: ""
    },
    {
        step: "contact-sidebar",
        content: (
            <div className="w-full h-full flex flex-col items-center justify-center gap-4">
                <div className="w-full h-full flex items-start gap-2">
                    <div>
                        <User />
                    </div>
                    <div className="font-normal text-[14px]">
                        {`در این قسمت می‌توانید دوستان خود را به ${ENVIRONMENT.brandName} اضافه کرده و فایل‌های خود را آن‌ها به اشتراک بگذارید.`}
                    </div>
                </div>
                <div className="flex flex-col w-full items-center">
                    <div
                        className="flex items-center justify-between h-[33px] px-2 w-[216px]"
                        style={{
                            boxShadow: "0px 8.38095px 31.4286px rgba(112, 144, 176, 0.12)"
                        }}
                    >
                        <div>
                            <Suspense fallback={<div className="skeleton w-full"></div>}>
                                <People1 />
                            </Suspense>
                        </div>
                        <div className="w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]" />
                        <div className={"w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]"} />
                    </div>
                    <div
                        className="flex items-center justify-between h-[33px] px-2 w-[247px]"
                        style={{
                            boxShadow: "0px 8.38095px 31.4286px rgba(112, 144, 176, 0.12)"
                        }}
                    >
                        <div>
                            <Suspense fallback={<div className="skeleton w-full"></div>}>
                                <People2 />
                            </Suspense>
                        </div>
                        <div className="w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]" />
                        <div className={"w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]"} />
                    </div>
                    <div
                        className="flex items-center justify-between h-[33px] px-2 w-[216px]"
                        style={{
                            boxShadow: "0px 8.38095px 31.4286px rgba(112, 144, 176, 0.12)"
                        }}
                    >
                        <div>
                            <Suspense fallback={<div className="skeleton w-full"></div>}>
                                <People3 />
                            </Suspense>
                        </div>
                        <div className="w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]" />
                        <div className={"w-[60px] h-[6px] bg-[#F3F5FA] rounded-[2px]"} />
                    </div>
                </div>
            </div>
        ),
        placement: "left",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: "#contact-sidebar",
        title: ""
    },
    {
        step: "report",
        content: (
            <div className="w-full h-full flex flex-col items-center gap-6">
                <div className="w-full h-full flex items-start gap-2">
                    <div>
                        <Frame />
                    </div>
                    <div className="font-normal text-[14px]">
                        {"در این قسمت می‌توانید گزارشی کامل از فعالیت‌های خود در بازه زمانی دلخواه مشاهده کنید."}
                    </div>
                </div>

                <div>
                    <Report width={270} height={100} />
                </div>
            </div>
        ),
        placement: "left",
        hideCloseButton: true, // hide the close button for this step
        hideFooter: false,
        showSkipButton: false,
        target: "#report",
        title: ""
    }
];

export default !isTouchScreen() ? stepsDesktop : stepsMobile;
